// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ba93960c","213":"af57e39c","455":"698d067b"}[chunkId] + ".chunk.js";
};